<template>
  <div>
    <!-- 顶部 -->
    <div class="top">
      <div class="top_bg"></div>
      <div class="top_img">
        <img :src="$common.getResourceUrl('pcweb/img/img_y1.png')" />
      </div>
      <div class="outline commonBox">
        <div v-for="(item, i) in topList" :key="i" class="outlineBox">
          <img alt="" :src="item" />
        </div>
      </div>
    </div>
    <!-- 轮播图部分 -->
    <div class="bg">
      <div class="swp commonBox">
        <div class="swpTitle">
          <div class="imgIcon">
            <img src="../assets/img/icon_dcp.png" />
          </div>
          <div class="title">严选师资，经验丰富更懂孩子</div>
          <div class="imgIcon" style="transform: rotateY(180deg)">
            <img src="../assets/img/icon_dcp.png" />
          </div>
        </div>
        <div class="swpSmTitle">答疑快，耐心教，保障孩子充分吸收知识内容</div>
        <div class="swpMain commonBox">
          <swiper />
        </div>
      </div>
    </div>
    <!-- 三图并排 -->
    <div class="threeImgBox_bg">
      <div class="threeImgBox commonBox">
        <div class="swpTitle">
          <div class="imgIcon">
            <img src="../assets/img/icon_dcp.png" />
          </div>
          <div class="title">三重教学服务，家长安心托付</div>
          <div class="imgIcon" style="transform: rotateY(180deg)">
            <img src="../assets/img/icon_dcp.png" />
          </div>
        </div>
        <div class="swpSmTitle">答疑快，耐心教，保障孩子充分吸收知识内容</div>
        <div class="threeImg" :class="{ active: mTop <= scrollTop }">
          <div class="threeImg_sm">
            <div>
              <img :src="$common.getResourceUrl('pcweb/img/img_y1.png')" />
            </div>
            <p>世界名校讲师，教学授课</p>
          </div>
          <div class="threeImg_sm">
            <div>
              <img :src="$common.getResourceUrl('pcweb/img/img_y2.png')" />
            </div>
            <p>专属辅导老师，1V1伴学</p>
          </div>
          <div class="threeImg_sm">
            <div>
              <img :src="$common.getResourceUrl('pcweb/img/img_y3.png')" />
            </div>
            <p>专业技术助教，随时答疑</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 最下方单图 -->
    <div class="oneImgBox_bg">
      <div class="oneImgBox commonBox">
        <div class="swpTitle">
          <div class="imgIcon">
            <img src="../assets/img/icon_dcp.png" />
          </div>
          <div class="title">辅导老师-1对1答疑</div>
          <div class="imgIcon" style="transform: rotateY(180deg)">
            <img src="../assets/img/icon_dcp.png" />
          </div>
        </div>
        <div class="swpSmTitle">答疑快，耐心教，保障孩子充分吸收知识内容</div>
        <div class="oneImg">
          <img
            :src="$common.getResourceUrl('pcweb/img/teacher_bg.cc6d191b.png')"
          />

          <div class="oneImg_1"></div>
          <div class="oneImg_2">
            <div v-for="(box, index) in 4" :key="index" class="dwSmBox">
              <div></div>
              <h4>微信答疑</h4>
              <p>课堂重点总结</p>
              <p>解答学习难题</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 轮播图子组件
import Swiper from './swiper/swiper.vue'
export default {
  name: '',
  components: {
    Swiper,
  },
  props: {},
  data() {
    return {
      mTop: null,
      topList: [
        this.$common.getResourceUrl('pcweb/indexImg/txt_a1.png'),
        this.$common.getResourceUrl('pcweb/indexImg/txt_a2 2.png'),
        this.$common.getResourceUrl('pcweb/indexImg/txt_a3.png'),
        this.$common.getResourceUrl('pcweb/indexImg/txt_a4.png'),
      ],
    }
  },
  computed: {
    scrollTop() {
      return this.$root.$children[0].scrollTop
    },
    pageBarHeight() {
      return this.$refs.pageBar ? parseInt(this.$refs.pageBar.barHeight) : 0
    },
    pageBarBg() {
      return this.scrollTop > this.pageBarHeight ? '#fff' : ''
    },
    pageBarLogoBg() {
      return this.scrollTop > this.pageBarHeight ? '' : '#fff'
    },
    pageBarColor() {
      return this.scrollTop > this.pageBarHeight
        ? 'rgba(0,0,0,0.7)'
        : 'rgba(255,255,255,0.7)'
    },
    activeBarColor() {
      return this.scrollTop > this.pageBarHeight ? '#000' : '#fff'
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.mTop = document.getElementsByClassName('threeImgBox_bg')[0].offsetTop
    })
  },
  methods: {
    onSwiper(swiper) {
      console.log(swiper)
    },
    onSlideChange() {
      console.log('slide change')
    },
  },
}
</script>
<style lang="scss" scoped>
@keyframes top {
  0% {
    opacity: 0;
    top: 50px;
  }
  100% {
    opacity: 1;
    top: 0px;
  }
}
.active {
  position: relative;
  animation: top 1s;
}
.commonBox {
  width: 980px;
  margin: 0 auto;
}
// 顶部
.top {
  position: relative;
  width: 100%;
  height: 900px;
  text-align: center;
  overflow: hidden;
  background-color: #fafbfc;
  .top_bg {
    margin-left: -70%;
    height: 550px;
    width: 240%;
    border-radius: 0 0 50% 50%;
    background-image: linear-gradient(180deg, #3fa9f0 0%, #5dd0f8 100%);
  }
  .top_img {
    background-color: rgba(255, 255, 255, 0.5);
    width: 980px;
    height: 520px;
    border-radius: 10px;
    margin: 0 auto;
    margin-top: -300px;
    padding: 10px;
    img {
      border-radius: 10px;
    }
  }
}
.outline {
  display: flex;
  justify-content: space-between;
  // margin-top: 40px;
  .outlineBox {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 150px;
    height: 100px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
// 轮播图部分
.bg {
  height: 800px;
  background-color: #fff;
  border-bottom: solid 1px #f2f2f2;
}
.swp {
  .swpMain {
    height: 420px;
  }
}
// 公共标题部分
.swpTitle {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 100px;
  margin-bottom: 15px;
  .title {
    font-size: 30px;
    color: #000000;
    margin: 0 15px;
    font-weight: 700;
  }
  .imgIcon {
    width: 40px;
    height: 30px;
  }
}
.swpSmTitle {
  display: flex;
  justify-content: center;
  margin-top: 8px;
  margin-bottom: 80px;
  font-size: 20px;
  letter-spacing: -1px;
  color: #828282;
}
// 三图并排部分
.threeImgBox_bg {
  background-color: #fafbfc;
  height: 620px;
  border-bottom: solid 1px #f2f2f2;
}
.threeImgBox {
  .threeImg {
    display: flex;
    justify-content: space-between;
    .threeImg_sm {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 300px;
      div {
        margin-bottom: 30px;
        img {
          border-radius: 8px;
        }
      }
      p {
        font-size: 24px;
        color: #444444;
      }
    }
  }
}
// 单图
.oneImgBox_bg {
  height: 600px;
  background-color: #fefefe;
  .oneImg {
    position: relative;
    padding-top: 60px;
    height: 295px;
    margin-top: -40px;
    img {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 395px;
      height: 310px;
      padding-top: -100px;
    }
    .oneImg_1 {
      width: 100%;
      height: 100%;
      background-color: rgba(72, 183, 248, 0.1);
      border-radius: 10px 20px 10px 0;
    }
    .oneImg_2 {
      position: absolute;
      right: 0;
      top: 0;
      display: flex;
      justify-content: space-around;
      width: 690px;
      height: 230px;
      .dwSmBox {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 30px 28px 0;
        width: 140px;
        height: 100%;
        background-color: #fff;
        box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.03);
        border-radius: 10px 20px 10px 20px;
        div {
          width: 50px;
          height: 50px;
          background-color: #f1f1f1;
          border-radius: 4px;
        }
        h4 {
          margin: 29px 0 10px;
          font-weight: 400;
          font-size: 18px;
        }
        p {
          font-size: 14px;
          color: #828282;
          margin-bottom: 5px;
        }
      }
    }
  }
}
</style>
